"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CargoUnit = void 0;
exports.CargoUnit = {
    _40Hq: '40HQ'
};
//# sourceMappingURL=cargo-unit.js.map